import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ActivityLogsCummunicationsService {

  private activityService = new Subject<any>();
  constructor() { }

  setActivityService(data: any) {
    this.activityService.next(data);
  }

  getActivityService(): Observable<any> {
    return this.activityService.asObservable();
  }
}
